declare global {
  interface NavigatorID {
    userAgentData?: {
      brands: string[]
      mobile: boolean
      platform: string
    }
  }
  interface Window {
    APP_VERSION?: string
  }
}

const macOsPlatforms = ['macOS', 'Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']

const platform = navigator.userAgentData?.platform || navigator.platform || ''

export const IS_IOS =
  /iPad|iPhone|iPod/.test(platform) ||
  (macOsPlatforms.includes(platform) && navigator.maxTouchPoints > 1)
export const IS_MAC_DESKTOP =
  macOsPlatforms.includes(platform) && navigator.maxTouchPoints === 0

export const MOD_KEY = IS_MAC_DESKTOP ? 'meta' : 'ctrl'

export const reactAppVersion: string = import.meta.env.APP_VERSION || ''
